// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/google-icons/icon.css
// module id = 421
// module chunks = 10